import React, { useState, useEffect } from 'react';
import {
    SelectInput,
    TextInput,
    SimpleForm,
    Edit,
    useNotify,
    useRedirect,
    CardActions,
    ListButton,
    useGetOne,
    Loading
} from 'react-admin';

const cardActionStyle = {
    zIndex: 2,
    display: 'block',
    marginLeft: 10,
};

const EditActions = ({ basePath, data, resource }) => (
    <CardActions style={cardActionStyle}>
        <ListButton basePath={basePath} />
    </CardActions>
);

const EditAppointmentSetting = (props) => {
    const {REACT_APP_API_ENDPOINT} = process.env;
    const [branches, setBranches] = useState([]);
    const notify = useNotify();
    const redirect = useRedirect();

    const { id } = props; // Extract the appointment setting ID from props

    const fetchBranches = async () => {
        try {
            const response = await fetch(REACT_APP_API_ENDPOINT+'/appointment/branches');
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            const branchChoices = data.result.map(branch => ({
                id: branch.id,
                name: `${branch.location} (${branch.city}, ${branch.state})`,
            }));
            return branchChoices;
        } catch (error) {
            return Promise.reject('Failed to fetch branches');
        }
    };

    useEffect(() => {
        fetchBranches()
            .then((branchChoices) => {
                setBranches(branchChoices);
            })
            .catch((error) => {
                notify(error, 'error');
            });
    }, [notify]);

    // Fetch the existing appointment setting data
    const { data: appointmentSetting, loading, error } = useGetOne('appointment/appointment-settings', id);

    useEffect(() => {
        if (error) {
            notify('Error fetching appointment setting data', 'error');
        }
    }, [error, notify]);

    const handleSuccess = () => {
        notify('Appointment setting has been successfully updated!', 'success', { autoHideDuration: 3000 });
        redirect('/appointment/appointment-settings');
    };

    // Generate hour and minute options
    const hourOptions = Array.from({ length: 24 }, (_, i) => ({ id: i, name: i < 10 ? `0${i}` : `${i}` }));
    const minuteOptions = Array.from({ length: 60 }, (_, i) => ({ id: i, name: i < 10 ? `0${i}` : `${i}` }));

    if (loading) return <Loading />; // Show loading state while fetching data

    return (
        <div style={{ backgroundColor: 'white', width: '600px' }}>
            <h2 style={{ marginLeft: 10 }}>Edit Appointment Setting</h2>
            <div style={{ width: '600px', margin: 'auto' }}>
                <Edit actions={<EditActions />}  {...props} undoable={false} onSuccess={handleSuccess}>
                    <SimpleForm initialValues={appointmentSetting}>
                        <SelectInput
                            source="branch_id"
                            label="Select Branch"
                            choices={branches}
                            optionText="name"
                            optionValue="id"
                            fullWidth
                        />

                        {/* Appointment Start Time */}
                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '1em' }}>
                            <SelectInput
                                source="appointment_start_hour"
                                label="Start Hour"
                                choices={hourOptions}
                                optionText="name"
                                optionValue="id"
                                style={{ marginRight: '1em' }}
                            />
                            <SelectInput
                                source="appointment_start_minute"
                                label="Start Minute"
                                choices={minuteOptions}
                                optionText="name"
                                optionValue="id"
                            />
                        </div>

                        {/* Appointment End Time */}
                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '1em' }}>
                            <SelectInput
                                source="appointment_end_hour"
                                label="End Hour"
                                choices={hourOptions}
                                optionText="name"
                                optionValue="id"
                                style={{ marginRight: '1em' }}
                            />
                            <SelectInput
                                source="appointment_end_minute"
                                label="End Minute"
                                choices={minuteOptions}
                                optionText="name"
                                optionValue="id"
                            />
                        </div>

                        <TextInput source="appointment_interval" label="Appointment Interval (in minutes)" fullWidth />

                        <TextInput source="max_appointments_per_slot" label="Max Appointments Per Slot" fullWidth />

                        <SelectInput
                            source="week_day"
                            label="Select Week Day"
                            choices={[
                                { id: 1, name: 'Monday' },
                                { id: 2, name: 'Tuesday' },
                                { id: 3, name: 'Wednesday' },
                                { id: 4, name: 'Thursday' },
                                { id: 5, name: 'Friday' },
                                { id: 6, name: 'Saturday' },
                                { id: 7, name: 'Sunday' },
                            ]}
                            fullWidth
                        />
                    </SimpleForm>
                </Edit>
            </div>
        </div>
    );
};

export default EditAppointmentSetting;
